import { AudienceTargetingIcon } from 'foundations-assets/icons/components/AudienceTargetingIcon';
import { CapIcon } from 'foundations-assets/icons/components/CapIcon';
import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { ContactsIcon } from 'foundations-assets/icons/components/ContactsIcon';
import { ContentIcon } from 'foundations-assets/icons/components/ContentIcon';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { MarketingIcon } from 'foundations-assets/icons/components/MarketingIcon';
import { PaidAdIcon } from 'foundations-assets/icons/components/PaidAdIcon';
import { SalesIcon } from 'foundations-assets/icons/components/SalesIcon';
import { SiteTreeIcon } from 'foundations-assets/icons/components/SiteTreeIcon';
import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';
export const SERVICE_COLORS = ['fill-accent-purple-subtle-alt', 'fill-accent-blue-subtle-alt', 'fill-accent-green-subtle-alt', 'fill-accent-yellow-subtle-alt'];
export const CAROUSEL_SERVICES_PROD = [{
  icon: WebsiteIcon,
  slug: 'website-development'
}, {
  icon: SiteTreeIcon,
  slug: 'website-design'
}, {
  icon: CodeIcon,
  slug: 'customer-integrations'
}, {
  icon: AudienceTargetingIcon,
  slug: 'account-based-marketing'
}, {
  icon: PaidAdIcon,
  slug: 'paid-advertising'
}, {
  icon: MarketingIcon,
  slug: 'full-inbound-marketing-services'
}, {
  icon: ContentIcon,
  slug: 'content-creation'
}, {
  icon: SalesIcon,
  slug: 'sales-enablement'
}, {
  icon: EmailIcon,
  slug: 'email-marketing'
}, {
  icon: CapIcon,
  slug: 'sales-coaching-and-training'
}, {
  icon: ContactsIcon,
  slug: 'customer-marketing'
}, {
  icon: DealsIcon,
  slug: 'sales-and-marketing-alignment'
}];
export const SUGGESTED_ACCREDITATIONS = [{
  buttonText: 'Find CRM implementation partners',
  description: 'Partners with proven experience delivering large scale, complex implementations of the HubSpot platform.',
  value: '43003',
  slug: 'crm-implementation',
  text: 'CRM Implementation'
}, {
  buttonText: 'Find Onboarding partners',
  description: 'Partners with proven experience onboarding for the Pro and Enterprise editions of Marketing and Sales Hubs.',
  value: '52001',
  slug: 'onboarding',
  text: 'Onboarding'
}, {
  buttonText: 'Find Custom Integration partners',
  description: 'Partners with proven experience in deploying complex, custom integrations based on unique client requirements.',
  value: '78002',
  slug: 'custom-integration',
  text: 'Custom Integration'
}, {
  buttonText: 'Find Data Migration partners',
  description: 'Partners with proven experience migrating data from legacy platforms and systems into the HubSpot platform.',
  value: '126001',
  slug: 'data-migration',
  text: 'Data Migration'
}, {
  buttonText: 'Find Platform Enablement partners',
  description: 'Partners with proven experience driving user adoption for large teams through customized training engagements and materials.',
  value: '63001',
  slug: 'platform-enablement',
  text: 'Platform Enablement'
}, {
  buttonText: 'Find Solutions Architecture Design partners',
  description: 'Partners with proven experience designing and configuring complex solutions across the HubSpot platform.',
  value: '126002',
  slug: 'solutions-architecture-design',
  text: 'Solutions Architecture Design'
}];